import React from "react";
import PrivacyNotice from "./PrivacyNotice";

interface TextDetailProps {
  currentIndex: number | null;
  content: string;
  loading: boolean;
  saving: boolean;
  message: string;
  onContentChange: (content: string) => void;
  onReload: () => void;
  onSave: () => void;
  onBackToList: () => void;
  onLogout: () => void;
}

const TextDetail: React.FC<TextDetailProps> = ({
  currentIndex,
  content,
  loading,
  saving,
  message,
  onContentChange,
  onReload,
  onSave,
  onBackToList,
  onLogout,
}) => {
  const [copySuccess, setCopySuccess] = React.useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(content);
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    } catch (error) {
      console.error("复制失败:", error);
    }
  };

  const buttonStyle = {
    padding: "8px 16px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#E0E0E0",
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "all 0.2s",
    backdropFilter: "blur(10px)",
    WebkitBackdropFilter: "blur(10px)",
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <h1
          style={{
            fontSize: "28px",
            fontWeight: "600",
            color: "#00FFD1",
            textShadow: "0 0 20px rgba(0, 255, 209, 0.5)",
          }}
        >
          文本详情
        </h1>
        <div style={{ display: "flex", gap: "12px" }}>
          <button
            onClick={onBackToList}
            style={buttonStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#00FFD1";
              e.currentTarget.style.boxShadow = "0 0 15px rgba(0, 255, 209, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            返回列表
          </button>
          <button
            onClick={onLogout}
            style={buttonStyle}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#00FFD1";
              e.currentTarget.style.boxShadow = "0 0 15px rgba(0, 255, 209, 0.3)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
              e.currentTarget.style.boxShadow = "none";
            }}
          >
            退出登录
          </button>
        </div>
      </div>
      <PrivacyNotice />
      <div
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.1)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          borderRadius: "16px",
          border: "1px solid rgba(255, 255, 255, 0.2)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
          padding: "24px",
        }}
      >
        {currentIndex !== null && (
          <div style={{ marginBottom: "16px", fontSize: "14px", color: "#00FFD1", display: "flex", alignItems: "center", gap: "8px" }}>
            编辑条目 #{currentIndex}
            <button
              onClick={handleCopy}
              disabled={loading}
              style={{
                padding: "4px 8px",
                fontSize: "12px",
                fontWeight: "500",
                color: "#E0E0E0",
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: "4px",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.6 : 1,
                transition: "all 0.2s",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.currentTarget.style.borderColor = "#00FFD1";
                  e.currentTarget.style.boxShadow = "0 0 10px rgba(0, 255, 209, 0.3)";
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
                  e.currentTarget.style.boxShadow = "none";
                }
              }}
            >
              {copySuccess ? "已复制" : "复制"}
            </button>
          </div>
        )}
        <div style={{ marginBottom: "16px" }}>
          <textarea
            value={content}
            onChange={(e) => onContentChange(e.target.value)}
            placeholder="在此输入文本内容..."
            style={{
              width: "100%",
              minHeight: "400px",
              padding: "16px",
              fontSize: "16px",
              backgroundColor: "rgba(255, 255, 255, 0.05)",
              border: "1px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              outline: "none",
              resize: "vertical",
              transition: "all 0.2s",
              color: "#E0E0E0",
            }}
            className="textarea-placeholder"
            onFocus={(e) => {
              e.target.style.borderColor = "#00FFD1";
              e.target.style.boxShadow = "0 0 15px rgba(0, 255, 209, 0.3)";
            }}
            onBlur={(e) => {
              e.target.style.borderColor = "rgba(255, 255, 255, 0.2)";
              e.target.style.boxShadow = "none";
            }}
            disabled={loading}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <div style={{ flex: 1 }}>
            {message && (
              <div
                style={{
                  padding: "8px 12px",
                  fontSize: "14px",
                  borderRadius: "8px",
                  backgroundColor: message.includes("成功") 
                    ? "rgba(0, 255, 209, 0.2)" 
                    : "rgba(255, 82, 82, 0.2)",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)",
                  color: message.includes("成功") ? "#00FFD1" : "#FF5252",
                  border: `1px solid ${message.includes("成功") ? "rgba(0, 255, 209, 0.3)" : "rgba(255, 82, 82, 0.3)"}`,
                }}
              >
                {message}
              </div>
            )}
          </div>
          <div style={{ display: "flex", gap: "12px" }}>
            <button
              onClick={onReload}
              disabled={loading}
              style={{
                padding: "10px 20px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#E0E0E0",
                backgroundColor: "rgba(255, 255, 255, 0.05)",
                border: "1px solid rgba(255, 255, 255, 0.2)",
                borderRadius: "8px",
                cursor: loading ? "not-allowed" : "pointer",
                opacity: loading ? 0.6 : 1,
                transition: "all 0.2s",
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
              }}
              onMouseEnter={(e) => {
                if (!loading) {
                  e.currentTarget.style.borderColor = "#00FFD1";
                  e.currentTarget.style.boxShadow = "0 0 15px rgba(0, 255, 209, 0.3)";
                }
              }}
              onMouseLeave={(e) => {
                if (!loading) {
                  e.currentTarget.style.borderColor = "rgba(255, 255, 255, 0.2)";
                  e.currentTarget.style.boxShadow = "none";
                }
              }}
            >
              {loading ? "加载中..." : "重新加载"}
            </button>
            <button
              onClick={onSave}
              disabled={saving}
              style={{
                padding: "10px 20px",
                fontSize: "14px",
                fontWeight: "500",
                color: "#0a0a0f",
                backgroundColor: "#00FFD1",
                border: "none",
                borderRadius: "8px",
                cursor: saving ? "not-allowed" : "pointer",
                opacity: saving ? 0.6 : 1,
                transition: "all 0.2s",
                boxShadow: "0 0 20px rgba(0, 255, 209, 0.4)",
              }}
              onMouseEnter={(e) => {
                if (!saving) {
                  e.currentTarget.style.backgroundColor = "#00FFFF";
                  e.currentTarget.style.boxShadow = "0 0 30px rgba(0, 255, 209, 0.6)";
                  e.currentTarget.style.transform = "translateY(-2px)";
                }
              }}
              onMouseLeave={(e) => {
                if (!saving) {
                  e.currentTarget.style.backgroundColor = "#00FFD1";
                  e.currentTarget.style.boxShadow = "0 0 20px rgba(0, 255, 209, 0.4)";
                  e.currentTarget.style.transform = "translateY(0)";
                }
              }}
            >
              {saving ? "保存中..." : "保存"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TextDetail;
